import Lookup from 'src/componentes/select2';

const StatusPesquisaClimaLookup = ({ ...rest }) => (
  <Lookup
    labelKey="descricao"
    valueKey="id"
    url="/StatusPesquisaClimaLookup"
    clearable
    {...rest}
  />
);

export default StatusPesquisaClimaLookup;
